/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux"; // import { setCurrentUser } from "../store/actions/authActions.js";
import { NavLink } from "react-router-dom";
import { Button, Checkbox, Modal } from "flowbite-react";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import instance, {
  fetchAllDepartments,
  fetchRatingDueDate,
} from "../../api/api";
import { initFlowbite } from "flowbite";
import { Loader } from "../../components/Loader";
import PerspectiveBadge from "../../components/PerspectiveBadge";
import { FormateDate } from "../../utils/FormatDate";
import TableSearchBar from "../../components/TableSearchBar";
// import { perspectives } from "../../constants/perspectives";
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  useReactTable,
  getSortedRowModel,
  SortingState,
} from "@tanstack/react-table";
import { sources } from "../../constants/sources";
import { useTenant } from "../../context/Tenant/TenantContext";
import { usePostHog } from "@posthog/react";

type Risk = {
  id?: string;
  riskNumber?: string;
  riskName: string;
  description: string;
  source: string;
  rootCause: string;
  objective: string;
  perspective: string;
  status?: string;
  checked?: boolean;
  createdAt?: string;
};
function AdminRiskSelection() {
  const { config, loading: tenantLoading } = useTenant();
  const posthog = usePostHog();
  const [allRisks, setAllRisks] = useState<any[]>([""]);
  const [currentRiskDetails, setCurrentRiskDetails] = useState<any>({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoadingRisks, setIsLoadingRisks] = useState(false);
  const closeEditRiskDrawerButtonRef = useRef<any>(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isEditDrawerOpen, setIsEditDrawerOpen] = useState(false);
  const [updatedRisk, setUpdatedRisk] = useState<Risk>({
    riskName: "",
    description: "",
    source: "",
    rootCause: "",
    objective: "",
    perspective: "",
  });
  const [approvedRisks, setApprovedRisks] = useState<any[]>([]);
  const [selectedRiskId, setSelectedRiskId] = useState<string>("");
  const [isApprovingRisks, setIsApprovingRisks] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const [moveRisksModal, setMoveRisksModal] = useState(false);

  const [dueDate, setDueDate] = useState<any>("");

  const editDrawerRef = useRef<any>(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [departments, setDepartments] = useState<any[]>([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [highlightedRiskId, setHighlightedRiskId] = useState<any>(null);
  const [filteredObjectives, setFilteredObjectives] = useState<string[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [sorting, setSorting] = useState<SortingState>([
    { id: "riskNumber", desc: false },
  ]);

  // const userId = localStorage.getItem("userId");

  const formatDate = (date: any) => {
    const d = new Date(date);
    d.setDate(d.getDate() - 1); // Subtract one day
    const month = `${d.getMonth() + 1}`.padStart(2, "0");
    const day = `${d.getDate()}`.padStart(2, "0");
    const year = d.getFullYear();
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    const fetchDueDate = async () => {
      const theDueDate = await fetchRatingDueDate();
      setDueDate(formatDate(theDueDate ? theDueDate : new Date()));
    };

    fetchDueDate();
    const fetchDepartments = async () => {
      setDepartments(await fetchAllDepartments());
    };
    fetchDepartments();
  }, []);

  useEffect(() => {
    posthog?.capture("page_viewed", { page: "admin_risk_selection" });
  }, [posthog]);

  const getAllRisks = async () => {
    try {
      let response;
      setIsLoadingRisks(true);
      if (selectedDepartment === "" || selectedDepartment === "All") {
        response = await instance.get(
          "/api/admin/riskRegister/riskRegisters/selections/UNDER_REVIEW"
        );
        setIsLoadingRisks(false);
      } else {
        response = await instance.get(
          `/api/admin/riskRegister/riskRegisters/department?departmentName=${selectedDepartment}`
        );
        setIsLoadingRisks(false);
      }
      initFlowbite();
      const risksWithChecked = response.data.data.map((risk: any) => ({
        ...risk,
        checked:
          risk.status === "UNDER_REVIEW" || risk.status === "REJECTED"
            ? false
            : true,
      }));
      setAllRisks(risksWithChecked);
    } catch (error) {
      setIsLoadingRisks(false);
      console.error(error);
    }
  };
  useEffect(() => {
    getAllRisks();
  }, []);

  const handleCheckboxClick = (id: any) => {
    // Find the clicked row and update its checked status
    const updatedData = allRisks.map((row: any) =>
      row.id === id ? { ...row, checked: !row.checked } : row
    );

    // Move the checked row to the top and update state
    const newlyApproved = updatedData.filter((row) => row.checked);
    
    // const selectedRisks = checkedRows.map((row) => row);
    // for (const risk of selectedRisks) {
    setApprovedRisks(newlyApproved);
    // }

    setAllRisks(updatedData);
  };

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  // Calculate the items to display based on the current page and items per page
  const paginatedRisks = React.useMemo(() => {
    let risksToDisplay = allRisks;
    
    // Apply search filter
    if (searchTerm) {
      risksToDisplay = risksToDisplay.filter((risk: any) =>
        Object.values(risk).some((value) =>
          String(value).toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }
    
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return risksToDisplay.slice(indexOfFirstItem, indexOfLastItem);
  }, [allRisks, currentPage, itemsPerPage, searchTerm]);

  const totalPages = Math.ceil(allRisks.length / itemsPerPage);

  const handleEditClick = (
    riskId: string,
    riskName: string,
    description: string,
    source: string,
    rootCause: string,
    perspective: string,
    objective: string
  ) => {
    setSelectedRiskId(riskId);
    setHighlightedRiskId(riskId);
    setIsEditDrawerOpen(true);
    const objectives = config.Factors.filter(
      (factor: any) => Object.keys(factor)[0] === perspective
    ).map((factor: any) => Object.values(factor)[0]);
    setFilteredObjectives(objectives);
    setCurrentRiskDetails({
      riskName: riskName,
      description: description,
      source: source,
      rootCause: rootCause,
      perspective: perspective,
      objective: objective,
    });
    setUpdatedRisk({
      riskName: riskName,
      description: description,
      source: source,
      rootCause: rootCause,
      perspective: perspective,
      objective: objective ? objective : "",
    });
  };

  const updateRisk = async (e: any) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await instance.put(
        `/api/employee/riskRegister/update/${selectedRiskId}`,
        updatedRisk
      );
      if (closeEditRiskDrawerButtonRef.current) {
        closeEditRiskDrawerButtonRef.current.click();
      }
      setIsSubmitting(false);
      await getAllRisks();
    } catch (error) {
      setIsSubmitting(false);
      return error;
    }
  };

  const deleteRisk = async (e: any) => {
    // e.preventDefault();
    setIsDeleting(true);

    try {
      await instance.delete(
        `/api/employee/riskRegister/delete/${selectedRiskId}`
      );
      if (closeEditRiskDrawerButtonRef.current) {
        closeEditRiskDrawerButtonRef.current.click();
      }
      setIsDeleting(false);
      await getAllRisks();
    } catch (error) {
      setIsDeleting(false);
      return error;
    }
  };

  const handleMoveRisksToNextStage = async () => {
    setIsApprovingRisks(true);

    try {
      for (const risk of approvedRisks) {
        if (
          risk.status === "UNDER_REVIEW" &&
          risk.objective !== "" &&
          risk.objective !== null
        ) {
          await instance.put(
            `/api/admin/riskRegister/update/status/${risk.id}`,
            {
              status: "ASSESSMENT_IN_PROGRESS",
            }
          );
        }
      }

      if (dueDate) {
        await instance.post(
          `/api/admin/riskDuedate/riskDuedates/create/ASSESSMENT_IN_PROGRESS`,
          {
            riskStatus: "ASSESSMENT_IN_PROGRESS",
            dueDate: dueDate,
          }
        );
      } else {
        await instance.post(
          `/api/admin/riskDuedate/riskDuedates/create/ASSESSMENT_IN_PROGRESS`,
          {
            riskStatus: "ASSESSMENT_IN_PROGRESS",
          }
        );
      }

      await instance.post("/api/admin/emails/stage-kickoff ", {
        stageName: "Risk Rating",
        role: "EMPLOYEE",
        riskStatus: "ASSESSMENT_IN_PROGRESS",
      });
      posthog?.capture("risk_selection_finalized", { risksCount: approvedRisks.length });
      setIsApprovingRisks(false);
      window.location.reload();
    } catch (error) {
      setIsApprovingRisks(false);
      console.error(error);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        editDrawerRef.current &&
        !editDrawerRef.current.contains(event.target)
      ) {
        setIsEditDrawerOpen(false);
        setHighlightedRiskId(null);
      }
    };

    if (isEditDrawerOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      setHighlightedRiskId(null);
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isEditDrawerOpen]);

  const columnHelper = createColumnHelper<Risk>();
  const columns = [
    columnHelper.accessor("riskNumber", {
      header: () => <span className="whitespace-nowrap">Risk Number</span>,
      cell: (info) => (
        <span className="whitespace-nowrap font-bold">
          <span className="mr-2">
            <Checkbox
              className={`${
                info.row.original.status === "UNDER_REVIEW" ||
                info.row.original.status === "REJECTED"
                  ? "text-caribbeanCurrent"
                  : "text-gray-500"
              }`}
              readOnly={
                info.row.original.status === "UNDER_REVIEW" ||
                info.row.original.status === "REJECTED"
                  ? false
                  : true
              }
              disabled={
                info.row.original.status === "UNDER_REVIEW" ||
                info.row.original.status === "REJECTED"
                  ? false
                  : true
              }
              checked={info.row.original.checked}
              onChange={() => handleCheckboxClick(info.row.original.id)}
            />
          </span>
          {info.getValue()}
        </span>
      ),
      footer: (info) => info.column.id,
    }),
        columnHelper.accessor("createdAt", {
      header: () => <span className="whitespace-nowrap">Created Date</span>,
      cell: (info) => (
        <span className="whitespace-nowrap">
          {info.getValue() ? FormateDate(info.getValue()) : ""}
        </span>
      ),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor((row) => row.perspective, {
      id: "perspective",
      cell: (info) => <PerspectiveBadge value={info.getValue()} />,
      header: () => <span>Perspective</span>,
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("objective", {
      header: () => "Objective",
      cell: (info) =>
        info.renderValue() || (
          <span className="text-red italic">{"-Required-"}</span>
        ),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("riskName", {
      header: () => "Risk Name",
      cell: (info) => info.renderValue(),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("source", {
      header: () => "Source",
      cell: (info) => info.renderValue(),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("description", {
      header: () => "Description",
      cell: (info) => info.renderValue(),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("rootCause", {
      header: () => "Root Cause",
      cell: (info) => info.renderValue(),
      footer: (info) => info.column.id,
    }),
    columnHelper.display({
      id: "actions",
      header: () => <span>Actions</span>,
      cell: ({ row }) => (
        <button
          type="button"
          className="w-auto flex justify-center items-center text-caribbeanCurrent hover:text-white border border-caribbeanCurrent hover:bg-caribbeanCurrent focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-xs px-4 py-2 text-center inline-flex me-2 mb-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-caribbeanCurrent dark:focus:ring-blue-800"
          data-drawer-target="drawer-edit-risk"
          data-drawer-show="drawer-edit-risk"
          data-drawer-placement="right"
          aria-controls="drawer-edit-risk"
          // disabled={userId !== risk.userId}
          onClick={() =>
            handleEditClick(
              row.original.id || "",
              row.original.riskName,
              row.original.description,
              row.original.source,
              row.original.rootCause,
              row.original.perspective,
              row.original.objective
            )
          }
        >
          <svg
            className="w-4 h-4 text-white-800 dark:text-white me-2"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m14.304 4.844 2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565 6.844-6.844a2.015 2.015 0 0 1 2.852 0Z"
            />
          </svg>
          Edit
        </button>
      ),
    }),
  ];

  const table = useReactTable<Risk>({
    data: paginatedRisks,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    state: { sorting },
    onSortingChange: setSorting,
  });

  if (tenantLoading || !config) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader size="xl" />
      </div>
    );
  }

  return (
    <>
      {/* <!-- Breadcrumb --> */}
      <nav
        className="justify-between  py-3 text-gray-700  sm:flex bg-gray-50"
        aria-label="Breadcrumb"
      >
        <ol className="inline-flex items-center mb-3 space-x-1 md:space-x-2 rtl:space-x-reverse sm:mb-0">
          <li>
            <div className="flex items-center">
              <NavLink
                to=""
                className=" text-sm font-medium text-gray-700 hover:text-blue-600  dark:text-gray-400 dark:hover:text-white"
              >
                Risk Registration
              </NavLink>
            </div>
          </li>

          <li aria-current="page">
            <div className="flex items-center ">
              <svg
                className="rtl:rotate-180 w-3 h-3 mx-1 text-gray-400"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 6 10"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 9 4-4-4-4"
                />
              </svg>
              <span className="mx-1 text-sm font-medium text-gray-500 md:mx-2 dark:text-gray-400">
                Risk Selection
              </span>
            </div>
          </li>
        </ol>
      </nav>
      <h1 className="text-xl mb-3 font-semibold text-gray-700">
        Risk Selection
      </h1>

      <form className="flex max-w-sm my-4 justify-center items-center">
        <label
          htmlFor="department"
          className="block mb-2 text-md font-medium text-gray-900 dark:text-white"
        >
          Department
        </label>
        <select
          id="department"
          className="ml-5 bg-gray-50 border border-caribbeanCurrent  text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          onChange={(e) => setSelectedDepartment(e.target.value)}
        >
          <option>All</option>
          {departments &&
            departments.map((department, index) => (
              <option key={index}>{department.name}</option>
            ))}
        </select>
      </form>

      <div className="border-2 border-dashed rounded-lg border-gray-300 dark:border-gray-600 mb-4">
        <div className="p-5 text-lg font-semibold text-left rtl:text-right text-gray-900 bg-white dark:text-white dark:bg-gray-800 sticky top-0 z-20">
          <div className="w-full flex items-center justify-between">
            <p>My Risks</p>
            <div className="flex flex-row gap-4 items-center justify-center">
              <div className="">
                <TableSearchBar
                  searchTerm={searchTerm}
                  onSearchChange={setSearchTerm}
                  placeholder="Search risks..."
                />
              </div>
            </div>
          </div>
        </div>
        <div className="rt-wrap relative sm:rounded-lg max-h-[calc(100vh-300px)] overflow-y-auto">
          <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
            <thead className="text-sm text-jet font-bold bg-gray-50 dark:bg-gray-700 dark:text-gray-400 sticky top-0 z-10">
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id}>
                  {headerGroup.headers.map((header) => {
                    const isSorted = header.column.getIsSorted();
                    const isActionsColumn = header.column.id === "actions";
                    return (
                      <th
                        scope="col"
                        key={header.id}
                        className={`px-6 py-3 ${
                          isActionsColumn
                            ? "sticky right-0 bg-gray-50 dark:bg-gray-700 z-10"
                            : ""
                        }`}
                        aria-sort={
                          isSorted === "asc"
                            ? "ascending"
                            : isSorted === "desc"
                            ? "descending"
                            : "none"
                        }
                      >
                        {header.isPlaceholder ? null : (
                          <button
                            type="button"
                            className={`flex items-center gap-1 select-none ${
                              header.column.getCanSort()
                                ? "cursor-pointer"
                                : "cursor-default"
                            }`}
                            onClick={header.column.getToggleSortingHandler()}
                            title={
                              header.column.getCanSort() ? "Sort" : undefined
                            }
                          >
                            {flexRender(
                              header.column.columnDef.header,
                              header.getContext()
                            )}
                            {header.column.getCanSort() && (
                              <span className="text-xs">
                                {isSorted === "asc"
                                  ? "▲"
                                  : isSorted === "desc"
                                  ? "▼"
                                  : "⇅"}
                              </span>
                            )}
                          </button>
                        )}
                      </th>
                    );
                  })}
                </tr>
              ))}
            </thead>
            {isLoadingRisks ? (
              <tbody>
                <tr>
                  <td colSpan={7} className="text-center">
                    <div className="flex justify-center items-center h-96">
                      <Loader size={"xl"} />
                    </div>
                  </td>
                </tr>
              </tbody>
            ) : (
              <tbody className="text-jet font-medium text-xs">
                {table.getRowModel().rows.map((row) => (
                  <tr
                    key={row.id}
                    className={`bg-gray border-b border-t hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 ${
                      highlightedRiskId === row.original.id ? "bg-gray-200" : ""
                    }`}
                  >
                    {row.getVisibleCells().map((cell) => {
                      const isActionsColumn = cell.column.id === "actions";
                      return (
                        <td
                          className={`px-6 py-4 align-top ${
                            isActionsColumn
                              ? "sticky right-0 bg-white dark:bg-gray-800"
                              : ""
                          }`}
                          key={cell.id}
                        >
                          {flexRender(
                            cell.column.columnDef.cell,
                            cell.getContext()
                          )}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            )}
          </table>
          {/* Pagination */}
          <div className="mt-4 pl-10 pr-10 pb-5 text-jet font-medium text-xs ">
            <nav aria-label="Page navigation">
              <ul className="flex justify-between">
                <li className="flex flex-row items-center">
                  <div>
                    <p>Show rows per page</p>
                  </div>
                  <div>
                    <select
                      className="ml-2 bg-gray-50 border border-caribbeanCurrent text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      onChange={(e) => setItemsPerPage(Number(e.target.value))}
                    >
                      <option>25</option>
                      <option>50</option>
                      <option>100</option>
                    </select>
                  </div>
                </li>
                <li className="flex flex-row gap-1 items-center text-gray-500">
                  <div>
                    <p>
                      {currentPage} of {totalPages === 0 ? 1 : totalPages}
                    </p>
                  </div>
                  <div>
                    <button
                      className="px-3 py-2 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg rounded-r-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      {"<"}
                    </button>
                  </div>
                  <div>
                    <button
                      className="px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg rounded-l-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      {">"}
                    </button>
                  </div>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>

      {/* drawers */}

      {/* edit risk */}
      {allRisks.length > 0 && (
        <div
          id="drawer-edit-risk"
          ref={editDrawerRef}
          className={`fixed top-0 right-0 z-50 h-screen p-4 overflow-y-auto transition-transform ${
            isEditDrawerOpen ? "translate-x-0" : "translate-x-full"
          } bg-white w-full md:w-1/4 dark:bg-gray-800`}
          tabIndex={-2}
          aria-labelledby="drawer-edit-risk-label"
        >
          <h5
            id="drawer-label"
            className="inline-flex items-center mb-6 text-base font-semibold text-gray-500  dark:text-gray-400"
          >
            Edit Risk
          </h5>
          <p className="text-sm my-4 text-gray-400">
            You are allowed to edit your risk before due date.
          </p>
          <button
            type="button"
            data-drawer-hide="drawer-edit-risk"
            aria-controls="drawer-edit-risk"
            className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 absolute top-2.5 end-2.5 inline-flex items-center justify-center dark:hover:bg-gray-600 dark:hover:text-white"
            ref={closeEditRiskDrawerButtonRef}
            onClick={() => setIsEditDrawerOpen(false)}
          >
            <svg
              className="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
            <span className="sr-only">Close menu</span>
          </button>
          <form
            onSubmit={updateRisk}
            className="border-2 border-dashed rounded-lg border-gray-300 dark:border-gray-600 mb-4 p-4"
          >
            <div className="mb-6">
              <label
                htmlFor="riskGoals"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Perspective
              </label>
              <select
                id="perspective"
                required
                className=" bg-gray-50 border border-caribbeanCurrent  text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                onChange={(e) => {
                  const selectedPerspective = e.target.value;

                  // Update the newRisk state
                  setUpdatedRisk((prevState) => ({
                    ...prevState,
                    perspective: selectedPerspective,
                  }));
                  // Filter objectives based on the selected perspective
                  // Update the filtered objectives
                  const objectives = config.Factors.filter(
                    (factor: any) =>
                      Object.keys(factor)[0] === currentRiskDetails.perspective
                  ).map((factor: any) => Object.values(factor)[0]);
                  setFilteredObjectives(objectives);
                }}
                value={updatedRisk.perspective || ""}
              >
                <option>Select Perspective</option>
                {config.Perspective.map((perspective: any, index: any) => (
                  <option key={index} value={perspective}>
                    {perspective}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-6">
              <label
                htmlFor="objective"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Objective
              </label>
              <select
                id="objective"
                required
                className="bg-gray-50 border border-caribbeanCurrent text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                onChange={(e) => {
                  setUpdatedRisk((prevState) => ({
                    ...prevState,
                    objective: e.target.value,
                  }));
                }}
                value={currentRiskDetails.objective}
              >
                <option>Select Objective</option>
                {filteredObjectives.map((objective, index) => (
                  <option key={index} value={objective}>
                    {objective}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-6">
              <label
                htmlFor="riskName"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Risk Name
              </label>
              <input
                type="text"
                id="riskName"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Risk title goes here"
                required
                onChange={(e) => {
                  setUpdatedRisk((prevState) => ({
                    ...prevState,
                    riskName: e.target.value,
                  }));
                }}
                defaultValue={currentRiskDetails.riskName}
              />
            </div>
            <div className="mb-6">
              <label
                htmlFor="riskSource"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Risk Source
              </label>
              <select
                id="riskSource"
                className=" bg-gray-50 border border-caribbeanCurrent  text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                onChange={(e) => {
                  setUpdatedRisk((prevState) => ({
                    ...prevState,
                    source: e.target.value,
                  }));
                }}
                value={updatedRisk.source || ""}
              >
                <option>Select Source</option>
                {sources.map((source, index) => (
                  <option key={index}>{source}</option>
                ))}
              </select>
            </div>
            <div className="mb-6">
              <label
                htmlFor="riskDescription"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Risk Description
              </label>
              <textarea
                id="riskDescription"
                rows={4}
                onChange={(e) => {
                  setUpdatedRisk((prevState) => ({
                    ...prevState,
                    description: e.target.value,
                  }));
                }}
                defaultValue={currentRiskDetails.description}
                className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Description goes here..."
              ></textarea>
            </div>
            <div className="mb-6">
              <label
                htmlFor="rootCause"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Root Causes
              </label>
              <textarea
                id="rootCause"
                rows={4}
                onChange={(e) => {
                  setUpdatedRisk((prevState) => ({
                    ...prevState,
                    rootCause: e.target.value,
                  }));
                }}
                defaultValue={currentRiskDetails.rootCause}
                className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Root cause goes here..."
              ></textarea>
            </div>
            <div>
              <div className="flex gap-4">
                <button
                disabled={isSubmitting}
                  type="submit"
                  className={`text-white bg-caribbeanCurrent hover:bg-blue-800 w-1/2 focus:ring-4 focus:ring-caribbeanCurrent font-medium rounded-lg text-sm px-5 py-2.5 mb-2 dark:bg-caribbeanCurrent dark:hover:bg-caribbeanCurrent focus:outline-none dark:focus:ring-caribbeanCurrent block ${isSubmitting ? "opacity-50 cursor-not-allowed" : ""}`}
                >
                  {isSubmitting ? <Loader size="sm" /> : "Save Risk"}
                </button>
                
                <button
                  type="submit"
                  className="text-black border-2 border-caribbeanCurrent hover:bg-caribbeanCurrent hover:text-white w-1/2 focus:ring-4 focus:ring-caribbeanCurrent font-medium rounded-lg text-sm px-5 py-2.5 mb-2 dark:bg-caribbeanCurrent dark:hover:bg-caribbeanCurrent focus:outline-none dark:focus:ring-caribbeanCurrent block"
                >
                  Cancel
                </button>
              </div>

              <div className="flex justify-end items-right">
                <button
                  style={{ cursor: "default"}}
                  className="text-white w-1/2 ml-2  bg-white border-white hover:bg-white hover:text-white focus:ring-4 focus:outline-none focus:ring-white font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:border-caribbeanCurrent dark:text-caribbeanCurrent dark:hover:text-white dark:hover:bg-caribbeanCurrent dark:focus:ring-caribbeanCurrent"
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                >
                  
                </button>
                <button
                  type="submit"
                  className="text-white w-1/2 ml-2 border-2 bg-riskRed border-riskRed hover:bg-white hover:text-black focus:ring-4 focus:outline-none focus:ring-caribbeanCurrent font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:border-caribbeanCurrent dark:text-caribbeanCurrent dark:hover:text-white dark:hover:bg-caribbeanCurrent dark:focus:ring-caribbeanCurrent"
                  onClick={(e) => {
                    e.preventDefault();
                    setOpenModal(true);
                  }}
                >
                  Delete Risk
                </button>
              </div>
            </div>
            <Modal
              show={openModal}
              size="md"
              onClose={() => setOpenModal(false)}
              popup
            >
              <Modal.Header />
              <Modal.Body>
                <div className="text-center">
                  <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
                  <div className="gap-0 mb-4">
                    <h3 className="text-lg font-normal text-gray-500 dark:text-gray-400">
                      Are you sure you want to delete this risk?
                    </h3>
                    <h4 className="text-gray-500 dark:text-gray-400">
                      <span className="font-bold text-black">Note:</span> You
                      can't undo this action
                    </h4>
                  </div>
                  <div className="flex justify-center gap-4">
                    <Button
                      className="bg-caribbeanCurrent"
                      onClick={(e) => {
                        e.preventDefault();
                        setOpenModal(false);
                        deleteRisk(null);
                      }}
                    >
                      {isDeleting ? <Loader size="sm" /> : "Delete"}
                    </Button>
                    <Button color="gray" onClick={() => setOpenModal(false)}>
                      Cancel
                    </Button>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          </form>
        </div>
      )}

      <div className="border-red-300 dark:border-gray-600 h-54 mb-4">
        <div className="space-y-6">
          {/* <h3 className="text-riskRed font-medium text-lg">
            Move To Rating Stage
          </h3> */}
          <Button
            onClick={() => setMoveRisksModal(true)}
            disabled={approvedRisks.length === 0}
            className="bg-riskRed font-bold"
          >
            Move Risks
          </Button>
          <Modal
            dismissible
            show={moveRisksModal}
            size="xl"
            onClose={() => setMoveRisksModal(false)}
            popup
          >
            {/* <Modal dismissible show={openModal} onClose={() => setOpenModal(false)}> */}
            <Modal.Header className="ml-3 p-5 border-b">
              <h4 className="font-bold text-gray-700 dark:text-gray-400">
                Move Risks To Invite Comments
              </h4>
            </Modal.Header>
            <Modal.Body>
              <div className="space-y-5 p-3">
                <p className="text-base leading-relaxed text-gray-700 dark:text-gray-400">
                  Are you sure you want to promote these risks to the comments
                  stage?
                </p>
                <p className="text-base leading-relaxed text-gray-700 dark:text-gray-400">
                  <span className="font-bold">Note: </span> You can't undo this
                  action
                </p>
              </div>
              {!dueDate && (
                <span className="space-y-5 p-3 text-red">
                  Please set a due date!
                </span>
              )}
            </Modal.Body>
            <Modal.Footer className="border-t">
              <Button
                color="gray"
                className="border-none text-riskRed"
                onClick={() => setMoveRisksModal(false)}
              >
                Cancel
              </Button>
              <Button
                className="bg-riskRed hover:bg-riskRed"
                disabled={!dueDate}
                onClick={() => {
                  handleMoveRisksToNextStage();
                }}
              >
                {isApprovingRisks ? <Loader size="sm" /> : "Confirm"}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </>
  );
  //   }
}

export default connect()(AdminRiskSelection);
